import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const productImporterSelectors = importerSelectors(
  'product.importer',
)

export default productImporterSelectors
